// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2ZESM","savePackageButton":"ClientWallet_savePackageButton__zmqrI"};